import moment from "moment";

import { EXECUTION_TEMPLATE } from "../../../types/templates/execution-brief/execution-brief-template.enum";
import { TExecutionBriefResults } from "../../../redux/reducers/executionBriefsReducer";
import { isValidDate } from "../../../utils/date-format.utils";

export const getExecutionBriefDefaultValues = (executionBrief: TExecutionBriefResults) => {
  switch (executionBrief.resourcetype) {
    case EXECUTION_TEMPLATE.DEALER_ADVERTISING:
      return selectDealerAdvertisingBriefTemplateData(executionBrief);

    case EXECUTION_TEMPLATE.WEB:
      return selectWebBannerBriefTemplateData(executionBrief);

    case EXECUTION_TEMPLATE.INSTORE_PRINT:
      return selectInStoreBriefTemplateData(executionBrief);

    case EXECUTION_TEMPLATE.INSTORE_DIGITAL:
      return selectInStoreBriefTemplateData(executionBrief);

    case EXECUTION_TEMPLATE.PAID_MEDIA:
      return selectPaidMediaTemplateData(executionBrief);

    case EXECUTION_TEMPLATE.EDM:
      return selectEdmTemplateData(executionBrief);

    case EXECUTION_TEMPLATE.SIMPLE:
    default:
      return selectSimpleBriefTemplateData(executionBrief);
  }
};

export const selectSimpleBriefTemplateData = (executionBrief: TExecutionBriefResults) => ({
  endAt: isValidDate(executionBrief.endAt ?? "") ? moment(executionBrief.endAt) : null,
  hasVendorCommitment: executionBrief.hasVendorCommitment ?? false,
  isRegional: executionBrief.isRegional ?? false,
  languages: executionBrief.languages ?? [],
  merchOwnerDetails: executionBrief.merchOwnerDetails ?? [],
  projectOverview: executionBrief.projectOverview ?? "",
  regions: executionBrief.regions ?? [],
  startAt: isValidDate(executionBrief.startAt ?? "") ? moment(executionBrief.startAt) : null,
  status: executionBrief.status ?? "draft",
});

export const selectWebBannerBriefTemplateData = (executionBrief: TExecutionBriefResults) => ({
  areVendorAssetsProvided: executionBrief.areVendorAssetsProvided ?? false,
  endAt: isValidDate(executionBrief.endAt ?? "") ? moment(executionBrief.endAt) : null,
  flyerPeriod: executionBrief.flyerPeriod ?? "",
  hasVendorCommitment: executionBrief.hasVendorCommitment ?? false,
  languages: executionBrief.languages ?? [],
  merchOwnerDetails: executionBrief.merchOwnerDetails ?? [],
  projectOverview: executionBrief.projectOverview ?? "",
  startAt: isValidDate(executionBrief.startAt ?? "") ? moment(executionBrief.startAt) : null,
  status: executionBrief.status ?? "draft",
  vendorAssetsLocation: executionBrief.vendorAssetsLocation ?? "",
});

export const selectDealerAdvertisingBriefTemplateData = (
  executionBrief: TExecutionBriefResults
) => ({
  isInventoryAvailable: executionBrief.isInventoryAvailable ?? false,
  isRegional: executionBrief.isRegional ?? false,
  languages: executionBrief.languages ?? [],
  merchOwnerDetails: executionBrief.merchOwnerDetails ?? [],
  regions: executionBrief.regions ?? [],
  status: executionBrief.status ?? "draft",
  storeNumber: executionBrief.storeNumber ?? "",
  storeType: executionBrief.storeType ?? "",
});

export const selectInStoreBriefTemplateData = (executionBrief: TExecutionBriefResults) => ({
  background: executionBrief.background ?? "",
  isRegional: executionBrief.isRegional ?? false,
  languages: executionBrief.languages ?? [],
  merchOwnerDetails: executionBrief.merchOwnerDetails ?? [],
  programObjectives: executionBrief.programObjectives ?? "",
  regions: executionBrief.regions ?? [],
  status: executionBrief.status ?? "draft",
});

export const selectPaidMediaTemplateData = (executionBrief: TExecutionBriefResults) => ({
  copyDirection: executionBrief.copyDirection ?? "",
  creativeDirection: executionBrief.creativeDirection ?? "",
  endAt: isValidDate(executionBrief.endAt ?? "") ? moment(executionBrief.endAt) : null,
  isRegional: executionBrief.isRegional ?? false,
  merchOwnerDetails: executionBrief.merchOwnerDetails ?? [],
  numberOfWorkOrdersRequested: executionBrief.numberOfWorkOrdersRequested ?? "",
  projectOverview: executionBrief.projectOverview ?? "",
  regions: executionBrief.regions ?? [],
  reportingMasterCampaignName: executionBrief.reportingMasterCampaignName ?? "",
  startAt: isValidDate(executionBrief.startAt ?? "") ? moment(executionBrief.startAt) : null,
  status: executionBrief.status ?? "draft",
});

export const selectEdmTemplateData = (executionBrief: TExecutionBriefResults) => ({
  areVendorAssetsProvided: executionBrief.areVendorAssetsProvided ?? false,
  audience: executionBrief.audience ?? "",
  businessObjectives: executionBrief.businessObjectives ?? "",
  copyDirection: executionBrief.copyDirection ?? "",
  creativeDirection: executionBrief.creativeDirection ?? "",
  executionDetails: executionBrief.executionDetails ?? "",
  hasVendorCommitment: executionBrief.hasVendorCommitment ?? false,
  isRegional: executionBrief.isRegional ?? false,
  keyMessage: executionBrief.keyMessage ?? "",
  languages: executionBrief.languages ?? [],
  merchOwnerDetails: executionBrief.merchOwnerDetails ?? [],
  programObjectives: executionBrief.programObjectives ?? "",
  regions: executionBrief.regions ?? [],
  status: executionBrief.status ?? "draft",
  vendorAssetsLocation: executionBrief.vendorAssetsLocation ?? "",
});
